import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from '@/context/AuthContext'
import { RequireAuth } from '@/components/layout/RequireAuth'
import { Layout } from '@/components/layout/Layout'
import { Login } from '@/pages/Login'
import { Overview } from '@/pages/Overview'
import { AgentsList } from '@/pages/agents/AgentsList'
import { AgentDetailLayout } from '@/pages/agents/AgentDetailLayout'
import { AgentOverviewTab } from '@/pages/agents/tabs/AgentOverviewTab'
import { AgentIdentityTab } from '@/pages/agents/tabs/AgentIdentityTab'
import { AgentPromptTab } from '@/pages/agents/tabs/AgentPromptTab'
import { AgentToolsTab } from '@/pages/agents/tabs/AgentToolsTab'
import { AgentSkillsTab } from '@/pages/agents/tabs/AgentSkillsTab'
import { AgentSchedulesTab } from '@/pages/agents/tabs/AgentSchedulesTab'
import { AgentPerformanceTab } from '@/pages/agents/tabs/AgentPerformanceTab'
import { AgentGatewaysTab } from '@/pages/agents/tabs/AgentGatewaysTab'
import { ToolsList } from '@/pages/tools/ToolsList'
import { ToolDetail } from '@/pages/tools/ToolDetail'
import { ToolNew } from '@/pages/tools/ToolNew'
import { SkillsList } from '@/pages/skills/SkillsList'
import { SkillDetail } from '@/pages/skills/SkillDetail'
import { SkillNew } from '@/pages/skills/SkillNew'
import { Platforms } from '@/pages/platforms/Platforms'
import { TeamView } from '@/pages/teams/TeamView'
import { JobBoardList } from '@/pages/jobboard/JobBoardList'
import { JobBoardDetail } from '@/pages/jobboard/JobBoardDetail'
import { JobBoardNew } from '@/pages/jobboard/JobBoardNew'
import { SchedulesGlobal } from '@/pages/schedules/SchedulesGlobal'
import { AdminUsers } from '@/pages/admin/AdminUsers'

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            element={
              <RequireAuth>
                <Layout />
              </RequireAuth>
            }
          >
            <Route path="/" element={<Overview />} />

            <Route path="/agents" element={<AgentsList />} />
            <Route path="/agents/:id" element={<AgentDetailLayout />}>
              <Route index element={<Navigate to="overview" replace />} />
              <Route path="overview" element={<AgentOverviewTab />} />
              <Route path="identity" element={<AgentIdentityTab />} />
              <Route path="prompt" element={<AgentPromptTab />} />
              <Route path="tools" element={<AgentToolsTab />} />
              <Route path="skills" element={<AgentSkillsTab />} />
              <Route path="schedules" element={<AgentSchedulesTab />} />
              <Route path="performance" element={<AgentPerformanceTab />} />
              <Route path="gateways" element={<AgentGatewaysTab />} />
            </Route>

            <Route path="/tools" element={<ToolsList />} />
            <Route path="/tools/new" element={<ToolNew />} />
            <Route path="/tools/:id" element={<ToolDetail />} />

            <Route path="/skills" element={<SkillsList />} />
            <Route path="/skills/new" element={<SkillNew />} />
            <Route path="/skills/:id" element={<SkillDetail />} />

            <Route path="/platforms" element={<Platforms />} />

            <Route path="/teams/cx" element={<TeamView metricsTable="cx_calls" title="CX" />} />
            <Route path="/teams/seo" element={<TeamView metricsTable="agent_runs" title="SEO" />} />

            <Route path="/job-board" element={<JobBoardList />} />
            <Route path="/job-board/new" element={<JobBoardNew />} />
            <Route path="/job-board/:id" element={<JobBoardDetail />} />

            <Route path="/schedules" element={<SchedulesGlobal />} />
            <Route path="/admin/users" element={<AdminUsers />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}
